// External Delivery Approval™ client — AdminOne-scoped (Bearer carelogix_adminone_token).
import axios from "axios";
import { getAdminToken } from "@/api/adminOneClient";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api/v2/oracle/ai-business`;

const http = axios.create({ baseURL: BASE, timeout: 45000 });
http.interceptors.request.use((cfg) => {
  const t = getAdminToken();
  if (t) {
    cfg.headers = cfg.headers || {};
    cfg.headers.Authorization = `Bearer ${t}`;
  }
  return cfg;
});

export const deliveryApprovalApi = {
  list: () => http.get("/delivery-approvals"),
  summary: () => http.get("/delivery-approvals/status/summary"),
  detail: (id) => http.get(`/delivery-approvals/${id}`),
  readiness: (id) => http.get(`/delivery-approvals/${id}/readiness`),
  evidence: (id) => http.get(`/delivery-approvals/${id}/evidence`),
  request: (id, notes) => http.post(`/delivery-approvals/${id}/request`, { notes: notes || "" }),
  approve: (id, body) => http.post(`/delivery-approvals/${id}/approve`, body),
  reject: (id, body) => http.post(`/delivery-approvals/${id}/reject`, body),
  suspend: (id, body) => http.post(`/delivery-approvals/${id}/suspend`, body),
  revoke: (id, body) => http.post(`/delivery-approvals/${id}/revoke`, body),
};

export const approvalExpiryApi = {
  overview: () => http.get("/approval-expiry/overview"),
  expiring: () => http.get("/approval-expiry/expiring"),
  expired: () => http.get("/approval-expiry/expired"),
  reattestationQueue: () => http.get("/approval-expiry/reattestation-queue"),
  ticker: () => http.get("/approval-expiry/ticker"),
  policy: () => http.get("/approval-expiry/policy"),
  patchPolicy: (body) => http.patch("/approval-expiry/policy", body),
  scan: () => http.post("/approval-expiry/scan"),
  detail: (id) => http.get(`/approval-expiry/${id}`),
  history: (id) => http.get(`/approval-expiry/${id}/history`),
  evidence: (id) => http.get(`/approval-expiry/${id}/evidence`),
  reattest: (id, body) => http.post(`/approval-expiry/${id}/reattest`, body),
  reactivate: (id, body) => http.post(`/approval-expiry/${id}/reactivate`, body),
  acknowledgeReminder: (id, body) => http.post(`/approval-expiry/${id}/acknowledge-reminder`, body || {}),
  suspend: (id, body) => http.post(`/approval-expiry/${id}/suspend`, body),
};
